{
	"type": "line",
	"minzoom": 7,
	"layout": {
		"line-cap": "round"
	},
	"paint": {
		"line-color": "#79230B",
		"line-width": ["interpolate", ["linear"], ["zoom"], 9, 1, 18, 4],
		"line-opacity": ["step", ["zoom"], ["case", ["get", "all_zoom_levels"], 1, 0], 11, 1]
	}
}
